<app-tenant-config-proxy [configPath]="'connectionChangeRequest.isActive'" [redirectOnDeactivated]="true">
  <ng-container *ngIf="isActive$ | async; else notActive">
    <app-order-request-wizard
      *ngIf="model$ | async as model"
      [model]="model"
      (onSubmitModel)="submitNewRequest($event)" />
  </ng-container>
  <ng-template #notActive>
    <app-error
      *ngIf="configLoaded$ | async"
      [errorMessage]="'Leider können Sie keinen Antrag für diese Anschlussart stellen.'">
      <button mat-raised-button color="primary" (click)="returnToEntry()">
        Zurück zur Wahl der Anschlussart
      </button>
    </app-error>
  </ng-template>
</app-tenant-config-proxy>
